import React from 'react';
import PropTypes from 'prop-types';

function Item({
  title,
  label,
  value,
  appear = true
}) {
  return (
    appear ?
    <div className="container_result">
      <p>{title}</p>
      <p><span>{value || '-'}</span>{label}</p>
    </div> : null
  );
}

Item.defaultProps = {};

Item.propTypes = {};

export default Item;



// WEBPACK FOOTER //
// ./src/components/Admin/Statistics/Users/Carts/Item.jsx